module.exports = __webpack_public_path__ + "static/media/bg.4520aa12.png";